import { FILTER_IS_LOADING } from "redux/actions/types/filter";

export function filterReducer(state = false, action) {
    switch (action.type) {
        case FILTER_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}